import { ICON_REGISTRY, type IconName } from './iconRegistry';

interface IconProps {
  name: IconName;
  className?: string;
  strokeWidth?: number;
}

export function Icon({ name, className, strokeWidth = 2 }: IconProps) {
  const LucideIconComponent = ICON_REGISTRY[name];
  return (
    <LucideIconComponent
      className={className}
      width="1em"
      height="1em"
      strokeWidth={strokeWidth}
      aria-hidden="true"
    />
  );
}

export type { IconName };
